import CheckoutConfigurationAPI from '@/api/configuration'
import logger from '@/utils/logger'
import clientLogger from '@/plugins/logger/core'
import { DEFAULT_OTP_CODE_LENGTH } from '@/utils/otp-code'
import Storage from '@/utils/storage'

const state = {
  configurations: {
    applePayEnabled: true,
    knetEnabled: false,
    ckoHubVersion: 'v2',
    userCheckoutFeedbackEnable: '0',
    userCheckoutConfig: [],
    pcidssEnabled: false,
    pcidssApplePayEnabled: false,
    simpleCheckoutEnabled: false,
  },
  fetching: false,
  fetched: false,
}

const logConfig = (logger, configResponse) => {
  try {
    logger.log('Fetched configuration', configResponse?.data ?? {})
  } catch (err) {
    console.error(`Failed to log configuration.`)
  }
}

const getters = {
  fetching(state) {
    return state.fetching ?? false
  },
  isEnabledApplePay(state) {
    return state.configurations.applePayEnabled !== false
  },
  isEnabledKnet(state) {
    return state.configurations.knetEnabled === true
  },
  isUsingCkoHubVersionV2(state) {
    return state.configurations.ckoHubVersion === 'v2'
  },
  userCheckoutFeedbackEnable(state) {
    return state.configurations.userCheckoutFeedbackEnable || []
  },
  userCheckoutConfig(state) {
    return state.configurations.userCheckoutConfig || []
  },
  skipPhoneNumberEntry(state) {
    return state.configurations?.skipPhoneNumberEntry ?? false
  },
  isPcidssEnabled(state) {
    return state.configurations?.pcidssEnabled ?? false
  },
  isPcidssApplePayEnabled(state) {
    return state.configurations?.pcidssApplePayEnabled ?? false
  },
  isSimpleCheckoutEnabled(state) {
    return state.configurations?.simpleCheckoutEnabled ?? false
  },
  isCardsV2EndpointEnabled(state) {
    return state.configurations?.cardsV2EndpointEnabled ?? false
  },
  isCvvFromCardDetailsV2Enabled(state) {
    return state.configurations?.cvvFromCardDetailsV2Enabled ?? false
  },
  isCardsV2CvvDetailsV2Enabled(state) {
    return (
      state.configurations?.cardsV2EndpointEnabled &&
      state.configurations?.cvvFromCardDetailsV2Enabled
    )
  },
  otpLength(_, getters) {
    return DEFAULT_OTP_CODE_LENGTH
  },
}

const mutations = {
  SET_FETCHED(state, fetched) {
    state.fetched = fetched
  },
  SET_FETCHING(state, fetching) {
    state.fetching = fetching
  },
  SET_DATA(state, configurations = {}) {
    state.configurations = { ...state.configurations, ...configurations }
  },
}

const actions = {
  init({ commit }) {
    const latestData = Storage.getConfiguration() || {}

    commit('SET_DATA', latestData)
  },
  async fetchCheckoutConfigurations(
    { dispatch, commit, state },
    { countryCode, checkoutId }
  ) {
    try {
      if (state.fetched) {
        return state.configurations || {}
      }

      if (!countryCode || state.fetching) {
        return {}
      }

      commit('SET_FETCHING', true)

      const res = await CheckoutConfigurationAPI.fetch({
        countryCode,
        checkoutId,
      })

      logConfig(clientLogger, res)

      if (res?.data?.skipPhoneNumberEntry) {
        dispatch('auth/setAutoSubmitPhone', true, { root: true })
      }

      commit('SET_DATA', res.data)
      commit('SET_FETCHING', false)
      commit('SET_FETCHED', true)

      return res?.data || {}
    } catch (error) {
      logger.error(error, {
        component: 'configuration',
        action: 'fetchCheckoutConfigurations',
        data: error.data || {},
      })

      commit('SET_DATA', {})
      commit('SET_FETCHING', false)

      return {}
    }
  },
}

export default { namespaced: true, state, getters, mutations, actions }
